<div class="go-back">
	<a href="javascript:void(0);" (click)="onCancel()">
		<i class="fa fa-arrow-left"></i>
		<h6 class="text-uppercase">add stip</h6>
	</a>
</div>
<div class="wrapper">
	<div class="rule-info">
		<div class="rule-body">
			<div class="rule-title">
				<h5 [innerHTML]="rule.displayText | safeHtml"></h5>
			</div>
			<div class="rule-badges">
				<span class="badge bg-secondary">{{ rule.ruleSetDisplayText }}</span>
				<span class="badge bg-secondary" *ngIf="rule.category !== 'Unknown'">{{
					rule.category
				}}</span>
			</div>
		</div>
	</div>
	<div class="stip-list">
		<cv-rule-stip-option-component
			*ngFor="let stip of stips; let index = index"
			[stip]="stip"
			[checked]="stipSelected && stipSelected.stipId === stip.stipId"
			[disabled]="saving"
			[index]="index + 1"
			(selected)="onStipSelected($event)"
		>
		</cv-rule-stip-option-component>
	</div>
	<hr class="separator" />
	<div class="form input-form" *ngIf="stips.length">
		<div>
			<textarea
				name="resolution"
				rows="5"
				[(ngModel)]="stipText"
				[disabled]="!stipSelected || saving"
			>
			</textarea>
		</div>
		<div class="text-right action-button">
			<p-button
				[disabled]="!stipText || !stipText.length || saving || !lockedBy.byTheUser"
				(onClick)="addStip()">
				<i class="pi pi-check" ></i>
				{{saving ? 'saving..' : 'post' }}
			</p-button>
		</div>
	</div>
</div>
